import { render, staticRenderFns } from "./BuzonSugerenciasFormComponent.vue?vue&type=template&id=9d85eef6&"
import script from "./BuzonSugerenciasFormComponent.vue?vue&type=script&lang=js&"
export * from "./BuzonSugerenciasFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports